// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mYHES{align-items:baseline;display:flex;max-width:100%;min-width:0}.TQd9z{flex-shrink:calc(1/var(--truncate-segments-weight, 1));min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cd5mg{flex-shrink:0;white-space:pre}.LNDxt.ui.popup{max-width:30rem;overflow-wrap:anywhere}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `mYHES`,
	"segment": `TQd9z`,
	"separator": `cd5mg`,
	"popup": `LNDxt`
};
module.exports = ___CSS_LOADER_EXPORT___;
